import {
  faCircle1,
  faCircle2,
  faCircle3,
  faCircle4,
} from '@awesome.me/kit-f3dc60f0d0/icons/classic/solid';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLingui } from '@lingui/react/macro';

import { IconPill } from './IconPill';

const getIconByStage = (stage?: number): IconProp | null => {
  switch (stage) {
    case 1:
      return faCircle1;
    case 2:
      return faCircle2;
    case 3:
      return faCircle3;
    case 4:
      return faCircle4;
    default:
      return null;
  }
};

interface Props {
  stage?: number;
}

export const StageIconPill = ({ stage }: Props) => {
  const { t } = useLingui();
  const icon = getIconByStage(stage);

  if (!icon) return null;

  return (
    <IconPill
      text={t`Stage`}
      icon={
        <FontAwesomeIcon className="vai-text-slate-100" icon={icon} size="xs" />
      }
    />
  );
};
